import NextErrorComponent from 'next/error';
import { PageContentLayout } from '@/creditflowresearch/ui/common/components/ContentLayouts';
import Deal from '@/creditflowresearch/ui/components/deals/Deal';
import withApplicationPropsV2 from '@/creditflowresearch/application/withApplicationPropsV2';
import getServerSideDealById from '@/creditflowresearch/application/Deal/serverSide/getServerSideDealById';
import getServerSideResearchData from '@/creditflowresearch/application/Research/serverSide/getServerSideResearchData';
import ParentPageContextProvider from '@/creditflowresearch/application/ParentPageContext';
import getServerSideDealBreadcrumbs from '@/creditflowresearch/application/Breadcrumbs/serverSide/getServerSideDealBreadcrumbs';
import { getServerSideBondsTileData,
} from '@/creditflowresearch/application/Bonds/serverSide/getServerSideBondsTileData';
import {
  getServerSideTraceTileData,
} from '@/creditflowresearch/application/Trace/serverSide/getServerSideTraceTileData';
import IBreadcrumb from '@/creditflowresearch/domain/vo/Breadcrumbs';
import PageFiltersContextProvider from '@/creditflowresearch/application/PageFilters/PageFiltersContext';
import { pageNotFound, pageRedirectTo, pageServiceUnavailable } from '@framework/router/Next/helpers';
import getServerSideArticlesTile
  from '@/creditflowresearch/application/ArticlesAndStats/Articles/ArticlesTile/serverSide/getServerSideArticlesTile';
import getRedirectByDealId from '@/creditflowresearch/application/Deal/serverSide/getRedirectByDealId';
import getServerSideRoadshows from '@/creditflowresearch/application/Roadshows/serverSide/getServerSideRoadshows';

export const getServerSideProps = withApplicationPropsV2(async (context) => {
  const { deal, hasServerError } = await getServerSideDealById(context);

  if (hasServerError) {
    return pageServiceUnavailable(context.res);
  }

  if (!deal) {
    const { code, url } = await getRedirectByDealId(context);
    if (code === '301' && url) {
      return pageRedirectTo(url, true);
    }

    if (code === '404') {
      return pageNotFound();
    }
  }

  const [researchData, bondTileData, traceTileData, articlesTilesData, roadshowsTileData] = await Promise.all([
    getServerSideResearchData(context, { isTile: true, deal }),
    getServerSideBondsTileData(context, { isConsumerOverview: false, deal }),
    getServerSideTraceTileData(context, false, deal),
    getServerSideArticlesTile(context, { deal }),
    getServerSideRoadshows(context, { deal, isTile: true }),
  ]);

  const breadcrumbs: IBreadcrumb[] = getServerSideDealBreadcrumbs(context, deal);

  return ({
    props: {
      deal,
      researchData,
      breadcrumbs,
      bondTileData,
      traceTileData,
      articlesTilesData,
      roadshowsTileData,
    },
  });
}, {
  dictionaries: ['documentTypeGroups', 'sizeDescriptions', 'ratingAgencies'],
  needsLegacyDictionaries: false,
});

const DealPage = (props) => {
  if (props.errorCode) {
    return <NextErrorComponent statusCode={ props.errorCode } />;
  }

  return (
    <PageFiltersContextProvider productIds={ [props?.deal?.productId] }>
      <ParentPageContextProvider parentProps={ {
        deal: props?.deal,
        research: props?.researchData,
        traceTileData: props?.traceTileData,
        bondTileData: props?.bondTileData,
        articlesTilesData: props?.articlesTilesData,
        roadshowsTileData: props?.roadshowsTileData,
      } }
      >
        <PageContentLayout>
          <Deal />
        </PageContentLayout>
      </ParentPageContextProvider>
    </PageFiltersContextProvider>
  );
};

export default DealPage;
